module.exports = [
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-çıkış uçlu başlangıç kiti",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo başlangıç paketi: suyunuzu filtrelenmiş, soğutulmuş ve sodalı hale getiren tek kumandalı mutfak bataryası. Soğutma ünitesi, filtre ve CO2 karbonlaştırma şişesi içerir. Yüksek U şeklinde çıkış ucu, krom kaplama.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-çıkış uçlu başlangıç kiti",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo başlangıç paketi: suyunuzu filtrelenmiş, soğutulmuş ve sodalı hale getiren tek kumandalı mutfak bataryası. Soğutma ünitesi, filtre ve CO2 karbonlaştırma şişesi içerir. Yüksek U şeklinde çıkış ucu, paslanmaz çelik görüntüsü.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-tipi Başlangıç Kiti",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo başlangıç paketi: suyunuzu filtrelenmiş, soğutulmuş ve sodalı hale getiren tek kumandalı mutfak bataryası. Soğutma ünitesi, filtre ve CO2 karbonlaştırma şişesi içerir. Yüksek L çıkış ucu, krom kaplama.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-tipi Başlangıç Kiti",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo başlangıç paketi: suyunuzu filtrelenmiş, soğutulmuş ve sodalı hale getiren tek kumandalı mutfak bataryası. Soğutma ünitesi, filtre ve CO2 karbonlaştırma şişesi içerir. Yüksek L şeklinde çıkış ucu, paslanmaz çelik görüntüsü.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-çıkış uçlu başlangıç kiti",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo başlangıç paketi: suyunuzu filtrelenmiş, soğutulmuş ve sodalı hale getiren tek kumandalı mutfak bataryası. Soğutma ünitesi, filtre ve CO2 karbonlaştırma şişesi içerir. Yüksek C şeklinde çıkış ucu, krom kaplama.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-çıkış uçlu başlangıç kiti",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo başlangıç paketi: suyunuzu filtrelenmiş, soğutulmuş ve sodalı hale getiren tek kumandalı mutfak bataryası. Soğutma ünitesi, filtre ve CO2 karbonlaştırma şişesi içerir. Yüksek C şeklinde çıkış ucu, paslanmaz çelik görüntüsü.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Tekli başlangıç seti",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono başlangıç paketi: filtrelenmiş, soğutulmuş ve sodalı su oluşturan tek su girişli batarya. Soğutma ünitesi, filtre ve CO2 karbonlaştırma şişesi içerir. Yüksek C şeklinde çıkış ucu, krom kaplama.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Tekli başlangıç seti",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono başlangıç paketi: filtrelenmiş, soğutulmuş ve sodalı su oluşturan tek su girişli batarya. Soğutma ünitesi, filtre ve CO2 karbonlaştırma şişesi içerir. Yüksek C şeklinde çıkış ucu, paslanmaz çelik görüntüsü.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Batarya ve L boyut su ısıtıcısı",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE RED Duo filtre seti ve suyu hemen ısıtan L şeklinde ısıtıcıya sahip mutfak bataryası (C şeklinde çıkış ucu). Krom kaplama. A sınıfı enerji verimliliği ve güvenlik özellikleri",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Batarya ve L boyut su ısıtıcısı",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE RED Duo filtre seti ve suyu hemen ısıtan L şeklinde ısıtıcıya sahip mutfak bataryası (L şeklinde çıkış ucu). Krom kaplama. A sınıfı enerji verimliliği ve güvenlik özellikleri",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Batarya ve L boyut su ısıtıcısı",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE RED Duo filtre seti ve suyu hemen ısıtan L şeklinde ısıtıcıya sahip mutfak bataryası (L şeklinde çıkış ucu). Mat paslanmaz çelik görünümlü kaplama. A sınıfı enerji verimliliği ve güvenlik özellikleri",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Batarya ve M boyut su ısıtıcısı",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE RED Duo filtre seti ve suyu hemen ısıtmak için M şeklinde ısıtıcıya sahip mutfak bataryası (C şeklinde çıkış ucu). Krom kaplama. A sınıfı enerji verimliliği ve güvenlik özellikleri",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Batarya ve M boyut su ısıtıcısı",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE RED Duo filtre seti ve suyu hemen ısıtmak için L şeklinde ısıtıcıya sahip mutfak bataryası (C şeklinde çıkış ucu). Krom kaplama. A sınıfı enerji verimliliği ve güvenlik özellikleri",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Batarya ve M boyut su ısıtıcısı",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE RED Duo filtre seti ve suyu hemen ısıtmak için L şeklinde ısıtıcıya sahip mutfak bataryası (C şeklinde çıkış ucu). Mat paslanmaz çelik görünümü. A sınıfı enerji verimliliği ve güvenlik özellikleri",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Batarya ve M boyut su ısıtıcısı",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant boiling water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Batarya ve L boyut su ısıtıcısı",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant boiling water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.com.tr/tr_tr/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.com.tr/tr_tr/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_tr_tr.json
// module id = 881
// module chunks = 0